export const invoiceOptionsCopy = {
  en: {
    title: 'Payment options',
    setup: 'Show payment options on invoices',
    company: 'Company defaults',
    scope: 'Settings for',
    inherit: 'Inherit company defaults',
    override: 'Use these options',
    hide: 'Hide all manual options',
    impact: 'Changes also apply to invoices at inheriting locations:',
    legacy: 'Older invoices without a location use company defaults.',
    show: 'Show on invoices',
    provider: 'Provider',
    recipient: 'Recipient display name',
    url: 'Actual HTTPS business link',
    host: 'Custom business hostname',
    zelle: 'Zelle enrolled recipient instructions',
    instructions: 'Short instructions (optional)',
    bankQr: 'Bank-issued Zelle QR (PNG, optional)',
    removeQr: 'Remove QR',
    preview: 'Customer preview',
    save: 'Save payment options',
    saved: 'Payment options saved.',
    unsaved: 'Unsaved changes. Save to update what customers see.',
    discardScope: 'Changing scope will discard the unsaved changes in this form. Continue?',
    discardReload: 'Reloading will discard the unsaved changes in this form. Continue?',
    failed: 'Could not save payment options. Your changes are still here.',
    loadFailed: 'Could not load payment options.',
    retry: 'Reload',
    up: 'Move up',
    down: 'Move down',
    warning:
      'Use an actual business link. A reusable link may contain a fixed amount or currency: preview it and compare it with each invoice. Blasto Clean does not prefill or update it.',
    verify:
      'Confirm the recipient, amount, currency and invoice number in your payment app. An account or eligible bank may be required. Staff must verify receipt before recording payment.',
    pending:
      'Opening a link, returning here or saying you paid does not mark this invoice paid. Please do not pay again while staff verifies your payment.',
    amount: 'Amount',
    currency: 'Currency',
    invoice: 'Invoice number',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Select and copy the text',
    open: 'Open payment link',
    view: 'View invoice',
    hidden: 'No manual payment options are shown.',
    inactive: 'Inactive internal method; not shown to customers.',
  },
  es: {
    title: 'Opciones de pago',
    setup: 'Mostrar opciones de pago en las facturas',
    company: 'Valores de la empresa',
    scope: 'Configuración para',
    inherit: 'Heredar los valores de la empresa',
    override: 'Usar estas opciones',
    hide: 'Ocultar todas las opciones manuales',
    impact: 'Los cambios también se aplican a las facturas de las ubicaciones que heredan:',
    legacy: 'Las facturas anteriores sin ubicación utilizan los valores de la empresa.',
    show: 'Mostrar en las facturas',
    provider: 'Proveedor',
    recipient: 'Nombre del destinatario',
    url: 'Enlace HTTPS real de la empresa',
    host: 'Nombre de dominio de la empresa',
    zelle: 'Instrucciones del destinatario inscrito en Zelle',
    instructions: 'Instrucciones breves (opcional)',
    bankQr: 'QR de Zelle emitido por su banco (PNG, opcional)',
    removeQr: 'Quitar QR',
    preview: 'Vista previa para el cliente',
    save: 'Guardar opciones de pago',
    saved: 'Se guardaron las opciones de pago.',
    unsaved: 'Tiene cambios sin guardar. Guárdelos para actualizar lo que ven los clientes.',
    discardScope: 'Cambiar la ubicación descartará los cambios sin guardar de este formulario. ¿Desea continuar?',
    discardReload: 'Volver a cargar descartará los cambios sin guardar de este formulario. ¿Desea continuar?',
    failed: 'No se pudieron guardar las opciones. Sus cambios se conservan.',
    loadFailed: 'No se pudieron cargar las opciones de pago.',
    retry: 'Volver a cargar',
    up: 'Subir',
    down: 'Bajar',
    warning:
      'Utilice un enlace real de su empresa. Un enlace reutilizable puede incluir un importe o una moneda fijos: revíselo y compárelo con cada factura. Blasto Clean no los completa ni actualiza.',
    verify:
      'Confirme el destinatario, el importe, la moneda y el número de factura en su aplicación de pagos. Puede necesitar una cuenta o un banco compatible. El personal debe verificar la recepción antes de registrar el pago.',
    pending:
      'Abrir un enlace, regresar aquí o indicar que pagó no marca la factura como pagada. No vuelva a pagar mientras el personal verifica su pago.',
    amount: 'Importe',
    currency: 'Moneda',
    invoice: 'Número de factura',
    copy: 'Copiar',
    copied: 'Copiado',
    copyFailed: 'Seleccione y copie el texto',
    open: 'Abrir enlace de pago',
    view: 'Ver factura',
    hidden: 'No se muestran opciones de pago manuales.',
    inactive: 'Método interno inactivo; no se muestra a los clientes.',
  },
};
